import { Component, Inject, Input, OnInit } from '@angular/core';
import { WINDOW } from '@core/http/window.providers';
import { NbComponentStatus } from '@nebular/theme';

@Component({
    selector: 'app-card-featured',
    templateUrl: './card-featured.component.html',
    styleUrls: ['./card-featured.component.scss'],
})
export class CardFeaturedComponent implements OnInit {
    @Input() link: string;
    @Input() title: string;
    @Input() description: string;
    @Input() date: string;
    @Input() location: string;
    @Input() filled: boolean = false;
    @Input() accent: NbComponentStatus = 'primary';
    @Input() tag: string;
    @Input() entity: string;
    @Input() entityAvatar: string;
    @Input() department: string;

    /**
     * Determina se o avatar da entidade
     * deve exibir apenas a imagem
     */
    onlyPicture;
    constructor(@Inject(WINDOW) private window: Window) {
        this.onlyPicture = this.window.innerWidth < 768;
    }

    ngOnInit(): void {}
}
